import { EvaluableType } from "@/services/backend/sample-error/sample-error";
import { Badge } from "@/shared/components/ui/badge";
import { ReactElement } from "react";

interface EvaluableBadgeProps {
  evaluableType: EvaluableType;
}

export default function EvaluableBadge({
  evaluableType,
}: EvaluableBadgeProps): ReactElement {
  if (evaluableType === EvaluableType.Evaluable) {
    return <Badge className="bg-green-600 text-white">Auswertbar</Badge>;
  }

  return <Badge className="bg-red-600 text-white">Nicht auswertbar</Badge>;
}
